/* eslint-disable import/no-cycle */
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';

import { failedRequest, successInRequest, successRemove } from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'alteracc', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((error) => toast.error(error));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'alteracc', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success('Registro inserido com sucesso.');
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((error) => toast.error(error));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'alteracc', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());

    if (isArray(erros)) erros.map((error) => toast.error(error));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@alteracaoCentroCusto/DATA_IN_REQUEST', requestData),
  takeLatest('@alteracaoCentroCusto/SUCCESS_REMOVE', requestData),
  takeLatest('@alteracaoCentroCusto/STORE_DATA', store),
  takeLatest('@alteracaoCentroCusto/RECORD_FILTERING', applyedFilters),
]);
